import { Box, Container, } from '@material-ui/core'
import { useEffect, useMemo, useState } from 'react'
import { Helmet } from 'react-helmet'
import { useDispatch } from 'react-redux'
import { useLocation } from 'react-router'
import AddUpdateDialog from 'src/components/common/addUpdateDialog';
import CommonStepper from 'src/components/common/commonStepper';
import CreateMoreBtn from 'src/components/common/createMoreBtn'
import FilterSection from 'src/components/common/filterSection'
import AddEditExcerciseMaster from 'src/components/exercise/AddEditExcerciseMaster'
// import DataTableNew from 'src/components/helperComponents/DataTable/DataTableNew'
import PlayerComponent from 'src/components/helperComponents/PlayerComponent'
import useQueryTable from 'src/hooks/useQueryTable'
import { DeleteLessonById, GetLessons } from 'src/redux/actions'
import { LocalTable } from 'src/ui/Table'
import { GetLessonTableColumns } from 'src/util/columns'

import AddEditLesson from '../components/lesson/AddEditLesson'

const steps = [
  'Create Lesson',
  'Create Practice',
];

const LessonList = () => {
  const dispatch = useDispatch()
  const location = useLocation();
  const [customFilterQuery, setCustomFilterQuery] = useState()
  const [recordToEdit, setRecordToEdit] = useState()
  const [mediaUrl, setMediaUrl] = useState()
  const [searchText, setSearchText] = useState(null)
  const [activeStep, setActiveStep] = useState(0);
  const [firstStepData, setFirstStepData] = useState(null);

  // Parse query params
  const searchParams = new URLSearchParams(location.search);
  const lessonId = searchParams.get("_id") || "";
  const chapterId = searchParams.get("chapterId") || "";

  const [{ pageIndex, pageSize }, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  })

  const { data, isLoading, isFetching, refetch } = useQueryTable({
    name: 'lessons',
    searchText: searchText,
    pageIndex: pageIndex,
    pageSize: pageSize,
    additionalFilters: customFilterQuery,
  })


  // filter Lesson by LessonId
  useEffect(() => {
    if (!lessonId) return;
    setCustomFilterQuery(prev => ({
      ...(prev || {}),
      _id: lessonId,
    }));
  }, [lessonId]);

  // filter Lesson by chapterId
  useEffect(() => {
    setCustomFilterQuery(prev => {
      const updatedQuery = { ...(prev || {}) };

      if (chapterId) {
        updatedQuery.chapter = chapterId;
      } else {
        delete updatedQuery.chapter;
      }

      return updatedQuery;
    });
  }, [chapterId]);

  const onDeleteRow = async record => {
    await dispatch(DeleteLessonById(record))
    refetch()
  }

  const columns = useMemo(() => GetLessonTableColumns(), [])

  const actionTitle = Object.keys(recordToEdit || {}).length === 0 ? "create-lesson" : "";

  useEffect(() => {
    if (recordToEdit) {
      setFirstStepData({
        lessonId: recordToEdit?._id,
        course: recordToEdit?.course?._id,
        chapter: recordToEdit?.chapter?._id,
        unit: recordToEdit?.unit?._id,
      });
    }
  }, [recordToEdit]);

  return (
    <>
      <Helmet>
        <title>Lessons | Langistan</title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: 'background.default',
          minHeight: '100%',
          py: 3,
        }}
      >
        <Container maxWidth={false}>
          {/* addButton filters & search section  */}
          <FilterSection
            type="Lesson"
            path="lessons"
            dispatcher={GetLessons}
            setSearchText={setSearchText}
            setRecordToEdit={setRecordToEdit}
            setCustomFilterQuery={setCustomFilterQuery}
            isViewFilterWithSearch={lessonId ? false : true}
          />

          {/* Lesson table data list */}
          <Box sx={{ pt: 3 }}>
            <LocalTable
              columns={columns}
              onEditClick={setRecordToEdit}
              onDeleteClick={onDeleteRow}
              additionalFilters={customFilterQuery}
              data={data}
              name="Lesson"
              isLoading={isLoading}
              isFetching={isFetching}
              setPagination={setPagination}
              addChildActionBtnTitle="Add Practice"
              addChildActionBtnClick={() => {
                setActiveStep(1);
              }}
              viewChildActionBtnTitle="View Practice"
              viewChildActionBtnUri={`/app/practice-list?lessonId=`}
            />
          </Box>

          {mediaUrl && (
            <PlayerComponent
              url={mediaUrl}
              onDialogCancel={() => setMediaUrl()}
            />
          )}

          {/* Add Update Lesson */}
          <AddUpdateDialog
            open={!!recordToEdit}
            title={
              activeStep === 0
                ? `${actionTitle ? "Create" : "Update"} Lesson`
                : "Create Practice List"
            }
            onClose={() => {
              setRecordToEdit();
              setFirstStepData(null);
              setActiveStep(0)
            }
            }
            maxWidth="lg"
          >
            {/*Stepper Box */}
            {actionTitle && <CommonStepper steps={steps} activeStep={activeStep} />}

            <Box mt={2}>
              {activeStep === 0 && (
                <AddEditLesson
                  selectedRow={recordToEdit}
                  refetch={refetch}
                  toggleDrawer={() => {
                    setRecordToEdit();
                    setFirstStepData(null);
                  }}
                  setFirstStepData={setFirstStepData}
                  setActiveStep={setActiveStep}
                  actionTitle={actionTitle}
                />
              )}

              {activeStep === 1 && (
                <AddEditExcerciseMaster
                  toggleDrawer={() => {
                    setRecordToEdit();
                    setFirstStepData(null);
                    setActiveStep(0)
                  }}
                  refetch={refetch}
                  firstStepData={firstStepData}
                  setActiveStep={setActiveStep}
                  actionTitle={actionTitle}
                />
              )}

              {/* Add practice success message & add new practice button */}
              {activeStep === 2 && (
                <CreateMoreBtn
                  notification="Practice created successfully!"
                  createMoreBtnTitle="+ Create more Practice"
                  onCreate={() => {
                    setActiveStep(1)
                  }}
                  onClose={() => {
                    setRecordToEdit()
                    setFirstStepData(null);
                  }}
                />
              )}

            </Box>
          </AddUpdateDialog>

        </Container>
      </Box >
    </>
  )
}

export default LessonList
